import React, { useState } from "react";
import { Box, Modal, Typography } from "@material-ui/core";

const modalBoxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 425,
  bgcolor: 'background.paper',
  border: '5px solid #ff0000',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
  color: 'white',
  background: 'black !important',
  textAlign: 'center'
};

const DeleteConfirmModal = ({ onClose, onConfirm }) => {
  const [modalOpen, setModalOpen] = useState(true);

  const handleConfirmDelete = () => {
    onConfirm();
    setModalOpen(false);
    onClose();
  };

  return (
    <Modal
      open={modalOpen}
      onClose={() => {
        setModalOpen(false);
        onClose();
      }}
    >
      <Box sx={modalBoxStyle}>
        <Typography variant="h6" component="h2" style={{ marginBottom: '20px', fontWeight: 'bold' }}>
          Are you sure you want to delete this game?
        </Typography>
        <Typography style={{ marginBottom: '30px', color: '#666', fontSize: '1.3rem', fontStyle: 'italic' }}>
          This action cannot be undone.
        </Typography>
        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
          <button
            onClick={() => onClose()}
            style={{
              padding: '10px 20px',
              border: '2px solid #ff0000',
              borderRadius: '5px',
              backgroundColor: 'transparent',
              color: '#ff0000',
              cursor: 'pointer',
              fontSize: '1.3rem',
              fontWeight: 'bold',
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirmDelete}
            style={{
              padding: '10px 20px',
              border: '2px solid #ff0000',
              borderRadius: '5px',
              backgroundColor: '#ff0000',
              color: 'black',
              fontWeight: 'bold',
              cursor: 'pointer',
              fontSize: '1.3rem',
              fontWeight: 'bold',
            }}
          >
            DELETE
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default DeleteConfirmModal; 